/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'FACILITY_VERIFIES_THAT_CONTRACTOR_PERSONNEL_HAVE_APPROPRIATE_QU',
              'FACILITY_PROVIDES_CONTRACTOR_PERSONNEL_WITH_A_SAFETY_ORIENTATIO',
              'FACILITY_MONITORS_CONTRACTED_PERSONNEL_TO_ENSURE_THEY_PERFORM_W',
              'SCAFFOLDING_IS_USED_IN_A_SAFE_WAY_I_E_SECURED_TO_A_PERMANENT_ST',
              'EXCAVATION_AND_OR_TRENCHING_WORK_IS_PERFORMED_IN_A_SAFE_WAY_I_E',
              'A_FIRE_EXTINGUISHER_IS_PROVIDED_BY_THE_FACILITY_WHEN_HOT_WORKS_',
              'IF_CHEMICALS_ARE_BROUGHT_INTO_THE_FACILITY_CONTRACTORS_SUBMIT_T',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_18: valueSchema,
  },
}
